module.exports = __webpack_public_path__ + "static/img/preview-04.7622e666.webp";